import {useState} from "react";
import DropDown from "../../../../shared/drop-down/dropDown";
import Slider from "../../../../shared/slider/slider";
import Checkbox from "../../../../shared/checkbox/checkbox";

const TripsFilter = () => {
    // const [trip, setTrip] = useState(10);
    const [km, setKm] = useState(750);
    const [ratings, setRatings] = useState(2);

    // const handleTrip = (val) => setTrip(val);
    const handleKm = (val) => setKm(val);
    const handleRatings = (val) => setRatings(val);

    return(
        <ul className={'filter-list round-corner-8'}>
            {/*<li>*/}
            {/*    <div className="filter-title">Mileage</div>*/}
            {/*    <div className="margin-b-30">*/}
            {/*        <DropDown list={['This week', 'This month', 'This year']} selected={'This week'}/>*/}
            {/*    </div>*/}
            {/*    <div className="">*/}
            {/*        <div className="margin-b-20"><Slider onChange={handleTrip} value={20} min={0} max={50}/></div>*/}
            {/*        <div className="sf-medium">{trip}</div>*/}
            {/*    </div>*/}
            {/*</li>*/}
            <li>
                <div className="filter-title">Alerts per 100 Kms</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Less than 30</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Less than 60</label>
                </div>
                <div className="dark-grey-color flex ">
                    <Checkbox checked={false}/>
                    <label className={'margin-l-10'}>Less than 100</label>
                </div>
            </li>
            <li>
                <div className="filter-title">Distance Driven</div>
                <div className="margin-b-30"><DropDown selected={'All'} list={['All', '100km', '200km']}/></div>
                <div className="">
                    <div className="margin-b-20"><Slider onChange={handleKm} value={750} min={0} max={2000}/></div>
                    <div className="sf-medium">{km}km</div>
                </div>
            </li>
            <li>
                <div className="filter-title margin-b-15">Trip Score</div>
                <div className="">
                    <div className="margin-b-20"><Slider onChange={handleRatings} step={0.5} value={2.0} min={0} max={5}/></div>
                    <div className="sf-medium">{ratings}</div>
                </div>
            </li>
            <li>
                <div className="filter-title">Select Group</div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Group 1</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Group 2</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={false}/>
                    <label className={'margin-l-10'}>Group 3</label>
                </div>
                <div className="dark-grey-color flex">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>Group 4</label>
                </div>
            </li>
            <li>
                <div className="filter-title margin-b-15">Vehicles</div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 05 HJ 1890</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 06 HJ 1360</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 07 HJ 2890</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 02 HJ 7830</label>
                </div>
                <div className="dark-grey-color flex margin-b-20">
                    <Checkbox checked={true}/>
                    <label className={'margin-l-10'}>KA 05 HJ 1890</label>
                </div>
            </li>
            {/*<li>*/}
            {/*    <div className="filter-title">Current Location (State)</div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Andhra Pradesh</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Assam</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Chandigharh</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Delhi</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex margin-b-20">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Gujarat</label>*/}
            {/*    </div>*/}
            {/*    <div className="dark-grey-color flex">*/}
            {/*        <Checkbox checked={true}/>*/}
            {/*        <label className={'margin-l-10'}>Karnataka</label>*/}
            {/*    </div>*/}
            {/*</li>*/}
        </ul>
    )
}
export default TripsFilter;
